import { axiosInstance } from './axiosInstance';

export const subscribeToTelegram = (telegramId) =>
    axiosInstance.get(`telegram_bot/subscribe_me`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
            telegram_id: telegramId,
        },
    });
